import { render, staticRenderFns } from "./textToPicture.vue?vue&type=template&id=23f56146&scoped=true&"
import script from "../jscript/textToPicture.js?vue&type=script&lang=js&"
export * from "../jscript/textToPicture.js?vue&type=script&lang=js&"
import style0 from "./textToPicture.vue?vue&type=style&index=0&id=23f56146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f56146",
  null
  
)

export default component.exports